<h4>{{ headline }}</h4>
<div class="logo-wall">
  <div class="logo-wall__item" *ngIf="googleLogo.logoSrc">
    <a [href]="googleLogo.url" target="_blank">
      <hdi-image [src]="googleLogo.logoSrc"></hdi-image>
    </a>
  </div>
  <div class="logo-wall__item" *ngIf="appleLogo.logoSrc">
    <a [href]="appleLogo.url" target="_blank">
      <hdi-image [src]="appleLogo.logoSrc"></hdi-image>
    </a>
  </div>
  <div class="logo-wall__item" *ngIf="deezerLogo.logoSrc">
    <a [href]="deezerLogo.url" target="_blank">
      <hdi-image [src]="deezerLogo.logoSrc"></hdi-image>
    </a>
  </div>
  <div class="logo-wall__item" *ngIf="spotifyLogo.logoSrc">
    <a [href]="spotifyLogo.url" target="_blank">
      <hdi-image [src]="spotifyLogo.logoSrc"></hdi-image>
    </a>
  </div>
  <div class="logo-wall__item" *ngIf="overcastLogo.logoSrc">
    <a [href]="overcastLogo.url" target="_blank">
      <hdi-image [src]="overcastLogo.logoSrc"></hdi-image>
    </a>
  </div>
</div>
